var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.484 4.0999C8.79454 4.0999 6.58397 6.35132 6.58397 9.16657L6.58397 14.8332C6.58397 15.1646 6.31534 15.4332 5.98397 15.4332C5.6526 15.4332 5.38397 15.1646 5.38397 14.8332L5.38397 9.16657C5.38397 5.7226 8.09828 2.8999 11.484 2.8999C14.8697 2.8999 17.584 5.72259 17.584 9.16657V16.7221C17.584 19.1229 15.6905 21.0999 13.3173 21.0999C10.9441 21.0999 9.05064 19.1229 9.05064 16.7221V9.16657C9.05064 7.809 10.1233 6.67768 11.484 6.67768C12.8446 6.67768 13.9173 7.809 13.9173 9.16657V16.7221C13.9173 17.0535 13.6487 17.3221 13.3173 17.3221C12.9859 17.3221 12.7173 17.0535 12.7173 16.7221V9.16657C12.7173 8.43773 12.1484 7.87768 11.484 7.87768C10.8196 7.87768 10.2506 8.43773 10.2506 9.16657V16.7221C10.2506 18.4942 11.6404 19.8999 13.3173 19.8999C14.9942 19.8999 16.384 18.4942 16.384 16.7221V9.16657C16.384 6.35132 14.1734 4.0999 11.484 4.0999Z",
    fill: "#C1C4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.47a15fe99a435d973e7dad0091074285.svg";
export { ForwardRef as ReactComponent };